import InfoWithTooltip from 'components/InfoWithTooltip/InfoWithTooltip';
import EXTERNAL_URLS from 'constants/externalUrls';
import { useTranslation } from 'react-i18next';

const MailRemindersBreadcrumbAdditionalContent = () => {
  const { t } = useTranslation();

  return (
    <InfoWithTooltip
      title={t('common.mainMenu.mailRemindersInfo')}
      link={EXTERNAL_URLS.mailReminders}
    />
  );
};

export default MailRemindersBreadcrumbAdditionalContent;
